import axios from "axios";
import React, { useRef, useState, useEffect } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { OtpInput } from 'reactjs-otp-input';
import { PiEye, PiEyeClosedLight } from "react-icons/pi";
import { OtpSend, UpdatePassword, VerifyOtp } from "../Reducer/apiCall";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Utils/Loader";
const ForgotPassword = () => {
  const dispatch = useDispatch()
  const { status } = useSelector((state) => state.Chat);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [otp, setOtp] = useState();

  const emailInputRef = useRef(null);
  const navigate = useNavigate()

  useEffect(() => {
    emailInputRef.current?.focus();
  }, []);

  const handleChange = (otp) => {
    setOtpError();
    setOtp(otp);
  }

  const handleVerifyEmail = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      setEmailError("Email is required.");
      return;
    }

    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
      return;
    }

    if (email) {
      const res = await dispatch(OtpSend({ email }))
      if (res.status == 200) {
        toast.success(res?.data?.message);
        setIsEmailVerified(true)
      } else {
        toast.error(res?.response?.data?.message || res?.message);
      }
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 4) {
      setOtpError("Otp is required.");
      return;
    }
    if (email && otp) {
      const payload = { email, otp }
      const res = await dispatch(VerifyOtp(payload))
      if (res.status == 200) {
        toast.success(res?.data?.message);
        setIsOtpVerified(true)
      } else {
        toast.error(res?.response?.data?.message || res?.message);
      }

    }
  };

  const handlePasswordUpdate = async () => {
   
    if (newPassword.length < 6) {
      return setPasswordError("Password must be at least 6 characters.");
    }
    if (newPassword !== confirmPassword) {
      return setPasswordError("Password not match")
    } else {
      const payload = { email, otp, newPassword }
      const res = await dispatch(UpdatePassword(payload))
      if (res.status == 200) {
        toast.success(res?.data?.message);
        navigate("/login")
      } else {
        toast.error(res?.response?.data?.message || res?.message);
      }
    }
  };

  return (
    <div className="flex flex-col items-center my-6 text-white min-h-[80vh]">
      {status == "loading" && <Loader />}
      <div className="p-3 w-[80%] sm:w-[60%] md:w-[50%] lg:w-[40%] min-w-72  border border-slate-400 bg-slate-800 rounded-lg h-fit mt-5 transition-all">
        <h2 className="text-2xl underline underline-offset-8 font-semibold text-white w-full text-center mb-4">
          Forgot Password
        </h2>

        <div>
          <h3 className="text-xl font-semibold p-1">Enter Email Address</h3>
          <div className="flex items-center">
            <input
              className="w-[80%] disabled:opacity-50 disabled:cursor-not-allowed border border-slate-700  py-4 px-8 rounded-full bg-white text-black"
              type="email"
              ref={emailInputRef}
              placeholder="Enter Email Address"
              value={email}
              required
              onChange={(e) => {
                setEmailError(""); setEmail(e.target.value)
              }
              }
              disabled={isEmailVerified ? true : false}
            />
            <button
              onClick={handleVerifyEmail}
              disabled={isEmailVerified ? true : false}
              className="w-[20%] disabled:opacity-50 disabled:cursor-not-allowed font-semibold hover:bg-slate-800 rounded-full ms-2  py-4 px-auto text-lg border border-slate-400 text-white bg-black transition-all"
            >
              Verify
            </button>

          </div>
          {emailError && <span className="text-red-500">{emailError}</span>}
        </div>



        <div>
          <h3 className="text-xl font-semibold p-1">Enter OTP</h3>
          <div className="flex items-center">
            <div className="w-[80%]  text-black">

              <OtpInput
                value={otp}
                focusStyle={true}
                onChange={handleChange}
                isInputNum={true}
                containerStyle={{ fontSize: "22px", padding: "5px" }}
                numInputs={4}

                separator={<span className="text-white ms-7">-</span>}
                isDisabled={!isEmailVerified || isOtpVerified}
                className="w-full " />
            </div>
            <button
              onClick={handleVerifyOtp}
              disabled={!isEmailVerified || isOtpVerified}
              className=" w-[20%] disabled:opacity-50 disabled:cursor-not-allowed font-semibold hover:bg-slate-800 rounded-full  ms-2  py-4 px-auto text-lg border border-slate-400 text-white bg-black transition-all"
            >
              Verify
            </button>
          </div>
          {otpError && <span className="text-red-500">{otpError}</span>}

        </div>

        <div>
          <h3 className="text-xl font-semibold p-1">Enter New Password</h3>
          <div className="relative">
            <input
              className="w-full disabled:opacity-50 disabled:cursor-not-allowed border border-slate-700 my-3 py-4 px-8 rounded-full bg-white text-black"
              type={showPassword ? "text" : "password"}
              placeholder="Enter New Password"
              value={newPassword}
              onChange={(e) => {
                setPasswordError("");
                setNewPassword(e.target.value)
              }
              }
              disabled={!isEmailVerified || !isOtpVerified}
            />
            <span
              onClick={() => {
                if (isEmailVerified && isOtpVerified) {
                  setShowPassword(!showPassword);
                }
              }}
              className={`cursor-pointer text-black/80 absolute right-5 top-8 ${(!isEmailVerified || !isOtpVerified) && "pointer-events-none opacity-50"
                }`}
            >
              {showPassword ? (
                <PiEyeClosedLight

                  fontSize={22} />
              ) : (
                <PiEye fontSize={22} />
              )}
            </span>
          </div>

          <h3 className="text-xl font-semibold p-1">Confirm New Password</h3>
          <div className="relative">
            <input
              className="w-full disabled:opacity-50 disabled:cursor-not-allowed border border-slate-700 my-3 py-4 px-8 rounded-full bg-white text-black"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => {
                setPasswordError("")
                setConfirmPassword(e.target.value)
              }
              }
              disabled={!isEmailVerified || !isOtpVerified}
            />
            <span
              onClick={() => {
                if (isEmailVerified && isOtpVerified) {
                  setShowConfirmPassword(!showConfirmPassword);
                }
              }}
              className={`cursor-pointer text-black/80 absolute right-5 top-8 ${(!isEmailVerified || !isOtpVerified) && "pointer-events-none opacity-50"
                }`}
            >
              {showConfirmPassword ? (
                <PiEyeClosedLight fontSize={22} />
              ) : (
                <PiEye fontSize={22} />
              )}
            </span>
          </div>

          {passwordError && <span className="text-red-500">{passwordError}</span>}
          <div className="text-center">

            <button
              onClick={handlePasswordUpdate}
              disabled={!isEmailVerified || !isOtpVerified}
              className="disabled:opacity-50 disabled:cursor-not-allowed  w-1/2 mx-auto font-semibold hover:bg-slate-800 rounded-full px-5 py-4 mt-5 text-lg border border-slate-400 text-white bg-black transition-all"
            >
              Update Password
            </button>
          </div>
        </div>

        <div className="w-full flex items-center mt-3">
          <div className="w-full h-[1px] bg-slate-600"></div>
          <Link to={"/login"}>
            <div className="p-3 font-semibold text-md hover:text-white">
              Login
            </div>
          </Link>
          <div className="w-full h-[1px] bg-slate-600"></div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
